<template>
  <div class="main-content" id="content">
    <h3 class="marginBottom20">
      {{ `${type === "add" ? "新增" : type === "edit" ? "编辑" : "查看"}固件` }}
    </h3>
    <el-card style="padding-left: 50px">
      <el-form
        ref="form"
        :model="form"
        label-position="top"
        label-width="80px"
        :rules="rules"
      >
        <el-form-item label="固件名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入"
            style="width: 400px"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="升级方式" prop="upgradeWay">
          <el-radio-group v-model="form.upgradeWay">
            <el-radio
              v-for="(item, index) in OUpgradeMethod"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <el-form-item label="升级范围" prop="upgradeScope">
          <el-radio-group
            v-model="form.upgradeScope"
            @change="
              () => {
                form.deviceIds = [];
                selectKey = [];
              }
            "
          >
            <el-radio
              v-for="(item, index) in OUpgradeScope"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="选择设备"
          v-if="form.upgradeScope == 2"
          prop="deviceIds"
        >
          <el-button type="primary" @click="selectTable">{{
            selectKey.length > 0 ? selectKey.length + "个设备" : "请选择"
          }}</el-button>
        </el-form-item>
        <el-form-item
          label="选择网关"
          v-if="form.upgradeScope == 3"
          prop="deviceIds"
        >
          <el-button type="primary" @click="selectTable">{{
            selectKey.length > 0 ? selectKey.length + "个网关" : "请选择"
          }}</el-button>
        </el-form-item>
        <div>产品类型</div>
        <div style="display: flex">
          <el-form-item label="产品系列" :span="8" prop="productSeries">
            <el-select v-model="form.productSeries" placeholder="请选择">
              <el-option
                v-for="(item, index) in OProductSeries"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="产品大类"
            class="marginLeft10"
            prop="productCategory"
          >
            <el-select
              v-model="form.productCategory"
              placeholder="请选择"
              @change="form.productSubCategory = ''"
            >
              <el-option
                v-for="(item, index) in OProductType"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="产品子类"
            class="marginLeft10"
            prop="productSubCategory"
          >
            <el-select v-model="form.productSubCategory" placeholder="请选择">
              <el-option
                v-for="(item, index) in EProductSubType[form.productCategory]"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型编号" class="marginLeft10" >
            <el-input v-model="typeReult" @change="parseInput"  ></el-input>
          </el-form-item>
        </div>

        <div>硬件版本</div>
        <div style="display: flex">
          <el-form-item label="PCB" :span="8" prop="hardwarePcb">
            <el-select v-model="form.hardwarePcb" placeholder="请选择">
              <el-option v-for="(item, index) in pcbList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="硬件版本"
            class="marginLeft10"
            prop="hardwareVersion"
          >
            <el-select
              v-model="form.hardwareVersion"
              placeholder="请选择"
              @change="form.hardwareBrandSubModel = ''"
            >
              <el-option
                v-for="(item, index) in hardwareNumOne"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="子版本"
            class="marginLeft10"
            prop="hardwareSubVersion"
          >
            <el-select v-model="form.hardwareSubVersion" placeholder="请选择">
              <el-option
                v-for="(item, index) in hardwareNumTwo"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="PCB编号" class="marginLeft10" >
            <el-input v-model="hardwarePcbResult" @change="pcbInput"></el-input>
          </el-form-item>
        </div>
        <!-- MCU -->
        <div style="display: flex">
          <el-form-item label="MCU" :span="8" prop="hardwareMcu">
            <el-select v-model="form.hardwareMcu" placeholder="请选择" >
              <el-option v-for="(item, index) in mcuList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌" class="marginLeft10" prop="hardwareBrand">
            <el-select
              v-model="form.hardwareBrand"
              placeholder="请选择"
              @change="form.hardwareBrandSubModel = ''"
            >
              <el-option
                v-for="(item, index) in OMcuBrand"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="品牌子型号"
            class="marginLeft10"
            prop="hardwareBrandSubModel"
          >
            <el-select
              v-model="form.hardwareBrandSubModel"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in EBrandSubModel[form.hardwareBrand]"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="MCU编号" class="marginLeft10" >
            <el-input v-model="hardwareMcuResult" @change="mcuInput"></el-input>
          </el-form-item>
        </div>

        <div>软件版本</div>
        <div style="display: flex">
          <el-form-item label="年月日" :span="8" prop="softwareData">
            <el-date-picker
              v-model="form.softwareData"
              type="date"
              placeholder="年月日"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item
            label="版本"
            class="marginLeft20"
            prop="softwareVersion"
          >
            <el-select v-model="form.softwareVersion" placeholder="请选择">
              <el-option
                v-for="(item, index) in version"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="子版本"
            class="marginLeft20"
            prop="softwareSubVersion"
          >
            <el-select
              v-model="form.softwareSubVersion"
              placeholder="请选择"
              :filterable="true"
            >
              <el-option
                v-for="(item, index) in subversion"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="上传固件" prop="firmwareUrl">
          <div v-if="versionWrong" style="color: #FF6347">
            bin文件版本号：{{ this.receivedVersion }},与表格输入不一致，请检查版本号！
          </div>
          <div v-if="versionMore" style="color: #FF6347">
            找到多个疑似版本号内容，请手动输入版本号！
          </div>
          <FormFileUpload
            :url="form.firmwareUrl"
            @upload="upload"
            :disabled="false"
            :limit="1"
            :maxSize="20"
            :accept="'bin'"
            :multiple="true"
            :isFileName="form.firmwareName"
            @version="versionGet"
          />
          <div style="color: #c0c1c3">文件格式：.bin</div>
        </el-form-item>

        <el-form-item label="版本描述" prop="versionDesc">
          <el-input
            type="textarea"
            v-model="form.versionDesc"
            style="width: 400px"
            maxlength="100"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="revert">返回</el-button>
          <el-button type="primary" @click="submit">确认</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <div v-if="form.upgradeScope == 2">
      <Table
        :show="showTable"
        @handSelected="handSelected"
        @closeTable="closeTable"
        :selectKey="selectKey"
      />
    </div>
    <div v-if="form.upgradeScope == 3">
      <TableGateway
        v-if="form.upgradeScope == 3"
        :show="showTable"
        @handSelected="handSelected"
        @closeTable="closeTable"
        :selectKey="selectKey"
      />
    </div>
  </div>
</template>

<script>
import {
  firmwareAdd,
  firmwareView,
  firmwareUpdate,
} from "@/api/upgrade/firmware";
import {
  OProductType,
  OProductSeries,
  OUpgradeMethod,
  OUpgradeScope,
  OMcuBrand,
  EBrandSubModel,
  EProductSubType
} from "@/enums/beCurrent/EBeCurrent";
import FormFileUpload from "@/components/formComponents/formFileUpload";
import Table from "../table";
import TableGateway from "../tableGateway";
import dayjs from "dayjs";

export default {
  name: "create",
  components: {
    FormFileUpload,
    Table,
    TableGateway,
  },
  data() {
    return {
      OProductType: OProductType,
      OProductSeries: OProductSeries,
      OUpgradeMethod: OUpgradeMethod,
      OUpgradeScope: OUpgradeScope,
      OMcuBrand: OMcuBrand,
      EBrandSubModel: EBrandSubModel,
      EProductSubType: EProductSubType,
      id: this.$route.query.id,
      disabled: this.$route.query.type === "view",
      type: this.$route.query.type,
      form: {
        firmwareUrl: [],
        firmwareName: "",
        productSeries:"",
        productCategory:"",
        productSubCategory: "",
        upgradeScope: 1,
        upgradeWay: 1,
        hardwarePcb:"",
        hardwareVersion:"",
        hardwareSubVersion:"",
        hardwareMcu:"",
        hardwareBrandSubModel: "",
        hardwareBrand: "",
        softwareData:"",
        softwareVersion:"",
        softwareSubVersion:"",
        deviceIds: [],
      },
      //校验规则
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        upgradeWay: [{ required: true, message: "请选择", trigger: "blur" }],
        upgradeScope: [{ required: true, message: "请选择", trigger: "blur" }],
        deviceIds: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              console.log(value, "eeeeeeeeeeeeeeee");
              if (value.length === 0) {
                callback(new Error("请选择"));
              } else {
                callback();
              }
            },
          },
        ],
        productSeries: [{ required: true, message: "请选择", trigger: "blur" }],
        productCategory: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        productSubCategory: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        hardwarePcb: [{ required: true, message: "请选择", trigger: "blur" }],
        hardwareVersion: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        hardwareSubVersion: [
          { required: true, message: "请选择", trigger: "blur" },
        ],

        hardwareMcu: [{ required: true, message: "请选择", trigger: "blur" }],
        hardwareBrand: [{ required: true, message: "请选择", trigger: "blur" }],
        hardwareBrandSubModel: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        firmwareUrl: [
          {
            required: true,
            message: "请上传固件",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value.length === 0) {
                callback(new Error("请上传"));
              } else {
                callback();
              }
            },
          },
        ],
        softwareData: [{ required: true, message: "请选择", trigger: "blur" }],
        softwareVersion: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        softwareSubVersion: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        versionDesc: [{ required: true, message: "请选择", trigger: "blur" }],
      },

      deviceList: [], //设备列表
      showTable: false,//表格显示
      selectKey: [], //选中的设备列表
      mcuList: [
      {
          value: "M",
          label: "M",
        },
      ],
      pcbList: [
      {
          value: "B",
          label: "B",
        },
      ],
      hardwareNumOne: [], //硬件版本
      hardwareNumTwo: [], //硬件子版本
      loadingSubmit: false,
      version: [],
      subversion: [],
      typeReult:"",
      hardwarePcbResult:"",
      hardwareMcuResult:"",
      softwareResult:"",
      receivedVersion:"",
      versionWrong: false,
      versionMore: false
    };
  },
  mounted() {
    let numbers = [];
    let subversion = [];
    let newHardwareNumOne = [];
    let newHardwareNumTwo = [];
    for (let i = 0; i <= 99; i++) {
      const number = i.toString().padStart(2, "0");
      // if (i != 0) {
      numbers.push({ value: "A" + number, label: "A" + number });
      newHardwareNumOne.push({ value: number, label: number });
      // }
      newHardwareNumTwo.push({ value: number, label: number });
    }
    for (let i = 1; i <= 999; i++) {
      const number = i.toString().padStart(3, "0");
      subversion.push({ value: number, label: number });
    }

    this.version = numbers;
    this.subversion = subversion;

    this.hardwareNumOne = newHardwareNumOne;
    this.hardwareNumTwo = newHardwareNumTwo;
    if (this.type == "edit") {
      this.getView();
    }
  },
  watch:{
    'form.productSeries'(){
      this.updateType();
    },
    'form.productCategory'(){
      this.updateType();
    },
    'form.productSubCategory'(){
      this.updateType();
    },
    'form.hardwarePcb'(){
      this.updatePcb();
    },
    'form.hardwareVersion'(){
      this.updatePcb();
    },
    'form.hardwareSubVersion'(){
      this.updatePcb();
    },
    'form.hardwareMcu'(){
      this.updateMcu();
    },
    'form.hardwareBrand'(){
      this.updateMcu();
    },
    'form.hardwareBrandSubModel'(){
      this.updateMcu();
    },
    'form.softwareData'(){
      this.updateSoft();
    },
    'form.softwareVersion'(){
      this.updateSoft();
    },
    'form.softwareSubVersion'(){
      this.updateSoft();
    },
  },
  methods: {
    async getView() {
      if (this.id) {
        const { data } = await firmwareView(this.id);
        this.form = {
          ...data,
          firmwareUrl: [data.firmwareUrl],
          softwareData: dayjs(data.softwareDataTime, "YYMMDD").format(
            "YYYY-MM-DD"
          ),
          productCategory: data.productCategory,
        };
        if (data.upgradeScope != 1) {
          let newDeviceIds = [];
          if (data.upgradeScope == 2) {
            newDeviceIds =  data.deviceIds && data.deviceIds.split(",").map((item, index) => {
              return {
                id: item,
                deviceId: data.deviceIdsStr.split(",")[index],
              };
            });
          }
          if (data.upgradeScope == 3) {
            newDeviceIds = data.deviceIds && data.deviceIds.split(",").map((item, index) => {
              return {
                id: item,
                gatewayId: data.deviceIdsStr.split(",")[index],
              };
            });
          }
          this.form.deviceIds = [...newDeviceIds];
          this.selectKey = [...newDeviceIds];
        }
        // if (data.upgradeScope == 3) {
        //   let newDeviceIds = data.deviceIds.split(",").map((item, index) => {
        //     return {
        //       id: item,
        //       deviceId: data.deviceIdsStr.split(",")[index],
        //     };
        //   });
        //   this.form.deviceIds = [...newDeviceIds];
        //   this.selectKey = [...newDeviceIds];
        // }
      }
    },
    //图片上传
    upload(e, name) {
      console.log("URL",e);
      if (Array.isArray(e)) {
        this.form.firmwareUrl = [...e];
      } else {
        this.form.firmwareUrl = [...this.form.firmwareUrl, e];
      }
      this.form.firmwareName = name;
      const filled = this.softwareResult.length + this.typeReult.length + this.hardwareMcuResult.length + this.hardwarePcbResult.length
      if(!filled){
        this.setSoft(this.form.firmwareName)
      }
      
      console.log('NAME',this.form.firmwareName)
    },

    setSoft(name){
      if(!name){
        return; 
      }
      const parts = name.split(' ');
      if(parts.length <= 3){
        return;
      }
      this.typeReult = parts[0];
      this.hardwareMcuResult = parts[1].slice(5,10)
      this.hardwarePcbResult = parts[1].slice(0, 5);
      this.softResult = parts[2]
      this.parseInput();
      this.mcuInput();
      this.pcbInput();
      this.softwareInput();
    },

    softwareInput(){
      const parts = this.setApart(this.softResult,6,3)
      this.form.softwareData = new Date(`20${parts[0].substr(0, 2)}-${parts[0].substr(2, 2)}-${parts[0].substr(4)}`)
      this.form.softwareVersion = this.version.find(option => option.label == parts[1])?.value || '';
      this.form.softwareSubVersion = this.subversion.find(option => option.label == parts[2])?.value || '';
      console.log('sofyware:', this.form.softwareVersion, this.form.softwareSubVersion)
    },

    //输入框改变下拉框
     parseInput(){
         const parts = this.typeReult.split('-').filter(Boolean);
         if(parts.length >= 1){
          this.form.productSeries = this.OProductSeries.find(option => option.label == parts[0])?.value || '';
         }
         if(parts.length >= 2){
          this.form.productCategory = this.OProductType.find(option => option.value == parts[1])?.value || '';
         }
         if(parts.length >= 3){
          if(this.form.productCategory == '0'){
            this.form.productSubCategory = this.gatewayO.find(option => option.value == parts[2])?.value || '';
          } else if(this.form.productCategory == '1') {
            this.form.productSubCategory = this.circuitBreakerO.find(option => option.value == parts[2])?.value || '';
          } else {
            this.form.productSubCategory = ''
          }
         }   
     },

     mcuInput(){
      const parts = this.setApart(this.hardwareMcuResult,1,2)
      if(parts.length >= 1){
        this.form.hardwareMcu = this.mcuList.find(option => option.value == parts[0])?.value || '';
      }
      if(parts.length >= 2){
        this.form.hardwareBrand = this.hardwareBig.find(option => option.value == parts[1])?.value || '';
      }
      if(parts.length >= 3){
          if(this.form.hardwareBrand == 'GD'){
            this.form.hardwareBrandSubModel = this.hardwareSubclassOne.find(option => option.value == parts[2])?.value || '';
          } else if(this.form.hardwareBrand == 'NX') {
            this.form.hardwareBrandSubModel = this.hardwareSubclassTwo.find(option => option.value == parts[2])?.value || '';
          } else {
            this.form.hardwareBrandSubModel = ''
          }
         }
     },

     pcbInput(){
      const parts = this.setApart(this.hardwarePcbResult,1,2)
      if(parts.length >= 1){
        this.form.hardwarePcb = this.pcbList.find(option => option.value == parts[0])?.value || '';
      }
      if(parts.length >= 2){
        this.form.hardwareVersion = this.hardwareNumOne.find(option => option.value == parts[1])?.value || '';
      }
      if(parts.length >= 3){
        this.form.hardwareSubVersion = this.hardwareNumTwo.find(option => option.value == parts[2])?.value || '';
      }
     },

    async submit() {
      if (this.loadingSubmit) {
        return;
      }
      let newVal = {
        ...this.form,
        softwareData: dayjs(this.form.softwareData).format("YYMMDD"),
        softwareDataTime: dayjs(this.form.softwareData).format("YYYY-MM-DD"),
        firmwareUrl: this.form.firmwareUrl[0],
      };
      if (this.loadingSubmit) {
        return;
      }
      if (this.form.upgradeScope != 1) {
        newVal.deviceIds = this.form.deviceIds.map((item) => item.id).join(",");
        if (this.form.upgradeScope == 2) {
          newVal.deviceIdsStr = this.form.deviceIds
            .map((item) => item.deviceId)
            .join(",");
        }
        if (this.form.upgradeScope == 3) {
          newVal.deviceIdsStr = this.form.deviceIds
            .map((item) => item.gatewayId)
            .join(",");
        }
      } else {
        newVal.deviceIds = "";
      }
      // if (this.form.upgradeScope == 3) {
      //   newVal.deviceIds = this.form.deviceIds.map((item) => item.id).join(",");
      //   newVal.deviceIdsStr = this.form.deviceIds
      //     .map((item) => item.deviceId)
      //     .join(",");
      // }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingSubmit = true;
          if (this.type == "add") {
            firmwareAdd({
              ...newVal,
            })
              .then((res) => {
                // 获取数据成功后的其他操作
                if (res.code == 200) {
                  this.loadingSubmit = false;
                  this.$router.go(-1);
                } else {
                  this.loadingSubmit = false;
                  this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                // loading.close();
                this.$message.error(err.msg);
                this.loadingSubmit = false;
              });
          } else {
            firmwareUpdate({
              ...newVal,
              id: this.id,
            })
              .then((res) => {
                // 获取数据成功后的其他操作
                if (res.code == 200) {
                  this.loadingSubmit = false;
                  this.$router.go(-1);
                } else {
                  this.loadingSubmit = false;
                  this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                // loading.close();
                this.$message.error(err.msg);
                this.loadingSubmit = false;
              });
          }
        }
      });
    },

    // 获取文件内部软硬件版本
    versionGet(softVersion, hardVersion) {

      if(softVersion.length > 1){
        this.versionMore = true;
        this.receivedVersion = softVersion;
      }

      if(softVersion != null && softVersion[0].length == 12){
        this.receivedVersion = softVersion[0];
        if (!this.form.softwareData || !this.form.softwareVersion || !this.form.softwareSubVersion) {
          this.form.softwareData = this.covertDate(this.receivedVersion.slice(0, 6));
          this.form.softwareVersion = this.receivedVersion.slice(6, 9);
          this.form.softwareSubVersion = this.receivedVersion.slice(9);
          this.versionWrong = false;
        } else {
          this.versionCheck();
        }
      }

      if(hardVersion != null && hardVersion[0].length == 10){
        if (!this.hardwarePcbResult || !this.form.hardwareMcuResult){
          this.hardwarePcbResult = hardVersion[0].slice(0, 5);
          this.hardwareMcuResult = hardVersion[0].slice(5);
          this.pcbInput();
          this.mcuInput();
        }
      }      
    },

    covertDate(date){
      const year = `20${date.slice(0, 2)}`;
      const month = date.slice(2, 4);
      const day = date.slice(4, 6);
      return `${year}-${month}-${day}`;
    },

    versionCheck(){
      if(this.receivedVersion == ""){
        this.versionWrong = false;
        return;
      }
      const writenVersion = dayjs(this.form.softwareData).format('YYYYMMDD').slice(2) + this.form.softwareVersion + this.form.softwareSubVersion;
      if(this.receivedVersion != writenVersion){
        this.$message.error('bin文件版本号和输入不一致，请检查版本号！')
        console.log('writenVersion', writenVersion)
        this.versionWrong = true;
      } else {
        this.versionWrong = false; 
      }
    },

    //打开设备表格
    selectTable() {
      this.showTable = true;
    },
    closeTable() {
      this.showTable = false;
    },
    handSelected(e) {
      this.selectKey = e;
      this.showTable = false;
      this.form.deviceIds = [...e];
    },
    revert() {
      this.$router.go(-1);
    },

    //获取输入数据
    updateType(){
      this.typeReult = 
      `${this.form.productSeries}-${this.form.productCategory}-${this.form.productSubCategory}`
    },
    updatePcb(){
      this.hardwarePcbResult = 
      `${this.form.hardwarePcb}${this.form.hardwareVersion}${this.form.hardwareSubVersion}`
    },
    updateMcu(){
      this.hardwareMcuResult = 
      `${this.form.hardwareMcu}${this.form.hardwareBrand}${this.form.hardwareBrandSubModel}`
    },
    updateSoft(){
      this.softwareResult = 
      `${this.form.softwareData}${this.form.softwareVersion}${this.form.softwareSubVersion}`
      this.versionCheck();
    },


    setApart(str,x,n){
      const parts = [str.slice(0, x), str.slice(x, x+n), str.slice(x+n, x+n*2)];
      console.log('setApart',parts)
      return parts
    },
  },
};
</script>

<style scoped>
::v-deep
  .el-select-dropdown
  .el-scrollbar
  .el-scrollbar__view
  .el-select-dropdown__item {
  padding: 0 20px !important;
}
</style>
